window.addEventListener('load', function () {
    const unfinishedFlow = window.localStorage.getItem('unfinished-flow');
    const lastVisitedVehicle = window.localStorage.getItem('last-visited-vehicle');

    if (unfinishedFlow) {
        const flowObject = JSON.parse(unfinishedFlow);
        const now = new Date().getTime();

        if (now > flowObject.timestamp) {
            window.localStorage.removeItem('unfinished-flow');
        }
    }

    if (lastVisitedVehicle) {
        const vehicleObject = JSON.parse(lastVisitedVehicle);
        const now = new Date().getTime();

        if (now > vehicleObject.timestamp) {
            window.localStorage.removeItem('last-visited-vehicle');
        }
    }
});
